export const RACES = ['house', 'senate', 'governor'];
export const TOTAL_NAMES = ['众议院', '参议院', '州长'];
export const RACE_TITLES = ['众议院选举', '参议院选举', '州长选举'];
export const MAJORITY = [218, 50, 25];
export const DEFAULT_TOTAL = [435, 100, 50];

export const NOTES = [
    {},
    {
        noteLeft: '34席不改选\n(含2名与民主党同一党团的独立参议员)',
        noteRight: '31席不改选',
    },
    {
        noteLeft: '6州不改选',
        noteRight: '8州不改选',
    },
];

export const SEAT_DESC_KEYS = [
    { dem: 'houseDemSeatDesc', gop: 'houseRepSeatDesc' },
    { dem: 'senateDemSeatDesc', gop: 'senateRepSeatDesc' },
    { dem: 'govDemSeatDesc', gop: 'govRepSeatDesc' },
];

/**
 * 是否盖戳由 totals.data.win 决定；为 true 时再按席位判断哪一方胜选。
 * 众议院：大于等于 218 的一方胜选。
 * 参议院：民主党大于 50 胜选，共和党大于等于 50 胜选。
 * 州长：大于 25 的一方胜选。
 * 双方同时达到各自门槛时，席位更多的一方胜选。
 */
export const getWinner = (type, dem, gop, majority, win = false) => {
    if (!win) return null;

    const demReached = type === 0 ? dem >= majority : dem > majority;
    const gopReached = type === 2 ? gop > majority : gop >= majority;

    if (demReached && !gopReached) return 'dem';
    if (gopReached && !demReached) return 'gop';
    if (demReached && gopReached) {
        if (dem > gop) return 'dem';
        if (gop > dem) return 'gop';
    }

    return null;
};

export const formatDeadline = value => {
    const match = String(value || '').match(/\d{4}-(\d{2})-(\d{2})\s+(\d{2}:\d{2})/);

    if (!match) return '';

    return `数据截止至 北京时间${Number(match[1])}月${Number(match[2])}日${match[3]}`;
};

/** 选票条和分享图只用 content.totals，不再叠加各州开票。 */
export const getRaceView = (source = {}, type = 0) => {
    const block = source[RACES[type]] || {};
    const rows = block.data || [];
    const totals = (source.totals && source.totals.data) || [];
    const summary = totals.find(item => item.name === TOTAL_NAMES[type]) || {};
    const notes = NOTES[type] || {};
    const pageConfig = source.pageConfig || {};
    const majority = MAJORITY[type];
    const dem = Number(summary.dem) || 0;
    const gop = Number(summary.gop) || 0;
    const win = summary.win === true;
    const winner = getWinner(type, dem, gop, majority, win);
    const seatKeys = SEAT_DESC_KEYS[type] || {};
    const demSeatDesc = String(pageConfig[seatKeys.dem] || '').trim();
    const gopSeatDesc = String(pageConfig[seatKeys.gop] || '').trim();

    return {
        type,
        title: RACE_TITLES[type],
        total: Number(summary.total) || DEFAULT_TOTAL[type],
        majority,
        dem,
        gop,
        win,
        winner,
        rows,
        updateTime: block.updateTime || '',
        noteLeft: demSeatDesc || notes.noteLeft || '',
        noteRight: gopSeatDesc || notes.noteRight || '',
    };
};
